import React from "react";
import "./QuickLinks.css";

const QuickLinks = () => {
  const cardStyle = {
    maxwidth: "600px", // set your desired width
    maxheight: "320px", // set your desired height
  };

  const imageStyle = {
    height: "260px", // set your desired image height
    objectFit: "cover", // maintain aspect ratio and cover the container
  };

  return (
    <div className="grandparent-quickLinks">
      <h2
        className="text-center py-4"
        style={{ fontFamily: "Raleway, sanf-serif", color: "#000" }}
      >
        Quick Links
      </h2>
      <div className="parent-quickLinks d-flex justify-content-around">
        <div class="row row-cols-1 row-cols-md-3 g-4 mb-4 child-quicklinks ">
          <div class="col">
            <div class="card-quicklinks card" style={cardStyle}>
              <a href="/Locations">
                <img
                  src="/diseasePic/private-clinic.jpg"
                  class="card-img-top"
                  alt="..."
                  style={imageStyle}
                />
              </a>
              <div class="card-body">
                <h5
                  class="card-title text-center"
                  style={{
                    color: "#000",
                    fontFamily: "'Lato', sans-serif",
                    textTransform: "uppercase",
                  }}
                >
                  Clinic Locations
                </h5>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="card-quicklinks card" style={cardStyle}>
              <a href="/TestProcedures">
                <img
                  src="/diseasePic/test-procedure.jpg"
                  class="card-img-top"
                  alt="..."
                  style={imageStyle}
                />
              </a>
              <div class="card-body">
                <h5
                  class="card-title text-center"
                  style={{
                    color: "#000",
                    fontFamily: "'Lato', sans-serif",
                    textTransform: "uppercase",
                  }}
                >
                  Test & Procedures
                </h5>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="card-quicklinks card" style={cardStyle}>
              <a href="/Fee">
                <img
                  src="/diseasePic/price-guide.jpg"
                  class="card-img-top"
                  alt="..."
                  style={imageStyle}
                />
              </a>
              <div class="card-body">
                <h5
                  class="card-title text-center"
                  style={{
                    color: "#000",
                    fontFamily: "'Lato', sans-serif",
                    textTransform: "uppercase",
                  }}
                >
                  Consultation Fee
                </h5>
              </div>
            </div>
          </div>
          {/* <div class="col">
            <div class="card-quicklinks card" style={cardStyle}>
              <a href="/Paediatric">
                <img
                  src="/diseasePic/paedaitric.jpg"
                  class="card-img-top"
                  alt="..."
                  style={imageStyle}
                />
              </a>
              <div class="card-body">
                <h5
                  class="card-title text-center"
                  style={{
                    color: "#000",
                    fontFamily: "'Lato', sans-serif",
                    textTransform: "uppercase",
                  }}
                >
                  Paediatric Dermatology Clinics
                </h5>
              </div>
            </div>
          </div> */}
          <div class="col">
            <div class="card-quicklinks card" style={cardStyle}>
              <a href="/SkinConditionTreated">
                <img
                  src="/diseasePic/skin-Condition.jpg"
                  class="card-img-top"
                  alt="..."
                  style={imageStyle}
                />
              </a>
              <div class="card-body">
                <h5
                  class="card-title text-center"
                  style={{
                    color: "#000",
                    fontFamily: "'Lato', sans-serif",
                    textTransform: "uppercase",
                  }}
                >
                  Skin Conditions Treated
                </h5>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="card-quicklinks card" style={cardStyle}>
              <a href="/TopicalTreatments">
                <img
                  src="/diseasePic/topical-treatment.jpg"
                  class="card-img-top"
                  alt="..."
                  style={imageStyle}
                />
              </a>
              <div class="card-body">
                <h5
                  class="card-title text-center"
                  style={{
                    color: "#000",
                    fontFamily: "'Lato', sans-serif",
                    textTransform: "uppercase",
                  }}
                >
                  Topical Treatments
                </h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuickLinks;
